import styled from 'styled-components';

export const TableContainer = styled.div`
  height: 100%;
  overflow-y: scroll;
`;

export const EmptyTableView = styled.div`
  min-height: 250px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-top: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N200
        : props.theme.atlas.semantic.color.surface.variant};
`;

export const CircleCheckbox = styled.input.attrs({ type: 'checkbox' })`
  width: 15px;
  height: 15px;
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? 'white'
      : props.theme.atlas.semantic.color.surface.default};
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid black;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  margin-right: 5px;
  &:checked {
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T300
        : props.theme.atlas.semantic.color.action.primary.default};
    border-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.turquoise.T300
        : props.theme.atlas.semantic.color.action.primary.default};
  }
`;

export const StyledTr = styled.tr`
  height: 40px;
  border-top: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N200
        : props.theme.atlas.semantic.color.surface.variant};
  cursor: pointer;
  &:hover {
    background-color: ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N200
        : props.theme.atlas.semantic.color.surface.variant};
  }
`;

export const StyledThead = styled.thead`
  position: sticky;
  top: 0;
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? 'white'
      : props.theme.atlas.semantic.color.surface.default};
  position: relative;
`;

export const Centered = styled.div`
  display: flex;
  align-items: center;
`;

export const Img = styled.img`
  margin: 0 0 0 8px;
`;
